// react-day-picker (9.5.x) と date-fns v4 の組み合わせでは、再レンダー時に CalendarMonth /
// CalendarDay の `.date` が Date ではなく **タイムスタンプ数値** で返ってくることがある
// （LP 空き状況ページで実測。値は正しいが型だけ number になる）。
// カスタムコンポーネント Nav / DayButton は `.date.getFullYear()` / `.getDate()` を直接呼ぶため、
// number が来ると `getFullYear/getDate is not a function` で throw し、React カレンダーが白画面になる。
// 値は有効なタイムスタンプなので `new Date(x)` で正しい Date に復元して防御する。
export const toDate = (value: Date | number): Date => (value instanceof Date ? value : new Date(value))
